import React, {useState, useEffect} from 'react';
import Select, { components } from 'react-select';
import { withTranslation } from 'react-i18next';
import "./selectField.scss";
import AsyncSelect from 'react-select/async';
import {Option} from "../../../models/Option";
import i18next from "i18next";
import BaseField from './baseField';

const CustomOption = (props: any) => {
    const handleChange = () => {
        const newValue = !props.isSelected;
        const newSelectedOptions = newValue
            ? [...props.selectProps.value, props.data]
            : props.selectProps.value.filter((option: any) => option.value !== props.data.value);

        props.selectProps.onChange(newSelectedOptions);
    };

    return (
        <components.Option {...props}>
            <input  hidden={props.data.value === "filterToViewMore"||!props.selectProps.isMulti}
                type="checkbox"
                className='w-10'
                checked={props.isSelected}
                onChange={handleChange}
            />{" "}
            {props.data.value === "filterToViewMore"?<span style={{color:"gray"}}>{props.label}</span>:props.label}
        </components.Option>
    );
};



const CustomMultiValue = (props: any) => {
    const { index, getValue } = props;
    const maxToShow = 2;
    const overflow = getValue().length - maxToShow;

    if (index < maxToShow) {
        return <components.MultiValue {...props} />;
    }

    if (index === maxToShow) {
        return (
            <components.MultiValue {...props}>
                + {overflow}
            </components.MultiValue>
        );
    }

    return null;
};



const MultiSelectField = ({ attr, label, options, selectedOptions, setSelectedOptions,multiSelect }: {attr:any, label:any, options:Option[], selectedOptions:any, setSelectedOptions:any,multiSelect:boolean}) => {
    const [defaultOptions, setDefaultOptions] = useState<Option[]>([]);
    const selectSinglePlaceHolder: string= i18next.t("common.action.select");

    const handleChange = (selected: any) => {
        if(multiSelect){
            const values = selected ? selected.map((option: any) => option.value) : [];
            setSelectedOptions(values);
        }else{
            const values = selected ? [selected.value] : [];
            setSelectedOptions(values);
        }
    };

    useEffect(() => {
        // Update defaultOptions when options change
        promiseOptions("").then((res)=>{
        setDefaultOptions(res);
        });
    }, [options]);

    const selectedValues = selectedOptions || []; 
    // Estilos vía prop `styles` en vez de los selectores `.css-<hash>-*` de selectField.scss:
    // esos hashes los genera Emotion en build time y pueden variar entre ambientes/builds,
    // haciendo que las reglas de posicionamiento del valor dejen de matchear silenciosamente.
    const customStyles = {
        container: (provided:any) => ({
            ...provided,
            width: '100%',
        }),
        option: (provided:any) => ({
            ...provided,
            display: 'inline-flex !important',
        }),
        control: (provided:any) => ({
            ...provided,
            width: '100%',
            minHeight: 0,
            padding: 2,
            paddingTop: '1.4rem', // misma separación que usan los inputs para no tapar el label flotante (baseField.scss)
            borderRadius: '0.25rem',
            border: 'none',
        }),
        valueContainer: (provided:any) => ({
            ...provided,
            padding: 0,
            margin: 0,
        }),
        multiValue: (provided:any) => ({
            ...provided,
            marginTop: 0,
        }),
        singleValue: (provided:any) => ({
            ...provided,
            backgroundColor: 'hsl(0, 0%, 90%)',
            width: 'max-content',
            padding: '1px 8px 1px 8px',
            borderRadius: 2,
            minWidth: '5rem',
            marginTop: 0,
        }),
        placeholder: (provided:any) => ({
            ...provided,
            marginTop: 0,
        }),
        indicatorsContainer: (provided:any) => ({
            ...provided,
            width: '3.5rem',
            paddingRight: 2,
            ...(!multiSelect && { paddingLeft: 22 }),
        }),
        indicatorSeparator: (provided:any) => ({
            ...provided,
            padding: 2,
            ...(!multiSelect && { display: 'none' }),
        }),
        dropdownIndicator: (provided:any) => ({
            ...provided,
            padding: 2,
            cursor: 'pointer',
        }),
        clearIndicator: (provided:any) => ({
            ...provided,
            padding: 2,
        }),
    };
    
    const promiseOptions = (inputValue: string) =>
        new Promise<Option[]>((resolve) => {
            var res=[];
            for(var i in options){
                if((options[i].label+"").toUpperCase().indexOf(inputValue.toUpperCase())==0)
                    res.push(options[i]);
                if(res.length>50){
                    res.push({label:i18next.t("filterToViewMore"),value:"filterToViewMore"});
                    break;
                }
            }
            resolve(res);

    });
    const getClassOfTypeMultiselect = () =>{
        let value= (!multiSelect ? "container-multiselect singleSelect" : "container-multiselect");
        return value;
    }

    return (
        <BaseField attr={attr} label={label} value={selectedValues}>
            <div className={getClassOfTypeMultiselect()}>
                <AsyncSelect loadOptions={promiseOptions}
                    defaultOptions={defaultOptions}
                    hideSelectedOptions={false}
                    isMulti={multiSelect}
                    isSearchable
                    closeMenuOnSelect={!multiSelect}
                    placeholder={!multiSelect && selectSinglePlaceHolder}
                    onChange={handleChange}
                    value={options.filter((option: any) => selectedValues.includes(option.value))}
                    components={{ Option: CustomOption, MultiValue: CustomMultiValue }}
                    inputId={attr}
                    className={`w-100`}
                    styles={customStyles}
                />
                {/*
                <Select
                    hideSelectedOptions={false}
                    options={options}
                    isMulti
                    isSearchable
                    closeMenuOnSelect={false}
                    placeholder={label}
                    onChange={handleChange}
                    value={options.filter((option: any) => selectedValues.includes(option.value))}
                    components={{ Option: CustomOption, MultiValue: CustomMultiValue }}
                    inputId={attr}
                    className="w-100"
                />
                */}
            </div>
        </BaseField>

        );
};

export default withTranslation()(MultiSelectField);

